import React, { useState } from "react";
import {
  Button,
  Col,
  Form,
  Input,
  Modal,
  Row,
  Typography,
  message,
  notification,
} from "antd";
import { ShopOutlined } from "@ant-design/icons";
import HAVETOApi from "../../../services/api/scratchcard/api";
import { useAppDispatch } from "../../../store/hooks";
import { userActions } from "../../../store/user";

interface PurchaseCardInterface {
  visible: boolean;
  onClose: () => void;
}

const PurchaseScratchCardModal: React.FC<PurchaseCardInterface> = ({
  visible,
  onClose,
}) => {
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const [loader, setLoader] = useState(false);

  const handleCancel = () => {
    onClose();
    form.resetFields();
  };

  const purchaseScratchCardAPI = HAVETOApi.purchaseScratchCard;

  const onFinish = async (values: any) => {
    setLoader(true);
    try {
      const result = await purchaseScratchCardAPI({ amount: values.amount });
      if (result.error) {
        notification.error({
          message:
            result.error.message || "Got error while card purchase!",
        });
      } else {
        notification.success({
          message: "Scratch card purchased successfully!",
        });
      }
      dispatch(userActions.getScratchCards());
      handleCancel();
    } catch (error) {
      message.error("Failed to purchase the scratch card. Please try again.");
    } finally {
      setLoader(false);
    }
  };

  return (
    <Modal
      visible={visible}
      title="Buy Scratch Card"
      centered
      onCancel={handleCancel}
      footer={null}
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        initialValues={{ amount: 1 }} // default value
      >
        <Row gutter={[0, 10]} align="middle" justify="center">
          <Col span={24}>
            <Form.Item
              label={<Typography.Text>Amount</Typography.Text>}
              name="amount"
              rules={[{ required: true, message: "Please enter amount" }]}
            >
              <Input
                prefix="HVT"
                type="number"
                placeholder="Enter Amount"
                disabled
              />
            </Form.Item>
          </Col>

          <Col span={24} style={{ textAlign: "center" }}>
            <Button
              type="primary"
              htmlType="submit"
              loading={loader}
              icon={<ShopOutlined />}
            >
              Purchase
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default PurchaseScratchCardModal;
